var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "points-box" }, [
      _c("div", { staticClass: "points-content" }, [
        _c("div", { staticClass: "illustration" }, [
          _c("div", { staticClass: "phone" }, [
            _c("div", { staticClass: "screen" }, [
              _c("div", { staticClass: "qr-code" }, [_vm._v("QR")]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "text" }, [
          _c("h2", [_vm._v("Punkte sammeln!")]),
          _c("p", [
            _vm._v(
              "Scanne den QR-Code mit deinem Smartphone und sammle exklusive Punkte."
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }